import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import EYE_CLOSE from "assets/svg/eyeClose.svg";
import EYE_OPEN from "assets/svg/eyeOpen.svg";
import { useEffect, useState } from "react";
import { userLogin } from "../../../axios/api";
import { toast } from "react-toastify";
import Loader from "../../../components/loader";
import { encryptData } from "utils/utils";
import axios from "axios";

export default function SignIn() {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [captchaSrc, setCaptchaSrc] = useState("");
  const [captchaId, setCaptchaId] = useState("");
  const [captchaText, setCaptchaText] = useState("");

  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Required"),
      password: Yup.string()
        .required("Required")
        .min(6, "Must be at least 6 characters")
        .max(20, "Must be at most 20 characters")
        .matches(/^\S+$/, "Password cannot contain only spaces"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        values.password = encryptData(values.password);
        const response = await userLogin({
          ...values,
          captchaId: captchaId,
          captchaTextResult: captchaText,
        });
        formik.values.password = "";
        if (response?.data?.success) {
          toast.success("Login Success!");
          localStorage.setItem("token", response?.data?.data?.token);
          localStorage.setItem(
            "refresh_token",
            response?.data?.data?.refreshToken
          );
          localStorage.setItem("role", response?.data?.data?.user);
          // localStorage.setItem(
          //   "username",
          //   response?.data?.data?.user?.username
          // );
          window.location.href = "/admin/announcement";
        } else {
          formik.values.password = "";
          toast.error(response?.data?.message);
          if (response?.data?.message === "Please reset your old password") {
            goToFogetPassword(response?.data);
          }
        }
      } catch (error: any) {
        console.log(error);
        toast.error(error?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    },
  });

  const goToFogetPassword = (data: any) => {
    navigate("/auth/resetpassword", { state: { response: data } });
  };

  const handlePasswordShow = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/admin/announcement");
    } else {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    fetchCaptcha();
  }, []);

  async function fetchCaptcha() {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/admin/user/generate-captcha`,
      { captchaId: captchaId }
    );
    setCaptchaId(response.data.id);
    setCaptchaSrc(response.data.captcha);
  }
  const refreshCaptcha = () => {
    fetchCaptcha();
  };

  const EyeIcon = showPassword ? EYE_OPEN : EYE_CLOSE;
  const passowordType = showPassword ? "text" : "password";
  return (
    <>
      {loading && <Loader />}
      <div className="flex min-h-[100%] items-center justify-center">
        <div className="w-[65%]">
          <div className="text-4xl	font-bold text-[#2B3674]">Sign In</div>
          <div className="mt-3	 text-base	font-normal text-[#A3AED0]">
            Enter your email and password to sign in!
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="py-2">
              <div className="py-3">
                <label
                  className="text-xl font-medium	text-[#2B3674]	"
                  htmlFor="email"
                >
                  Email <span className="text-[#008BD2]">*</span>
                </label>
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  className="h-[3.5rem] w-[100%] rounded-[1rem] border-[1px]  border-[#A3AED0] p-5 text-lg"
                  placeholder="Enter email here"
                  autoComplete="off"
                />
              </div>

              {formik.touched.email && formik.errors.email ? (
                <div className="text-lg	text-red-600">{formik.errors.email}</div>
              ) : null}
            </div>

            <div className="py-2">
              <div className="py-3">
                <label
                  className="text-xl font-medium	text-[#2B3674]	"
                  htmlFor="password"
                >
                  Password <span className="text-[#008BD2]">*</span>
                </label>
              </div>
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  type={passowordType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                  className="h-[3.5rem] w-[100%] rounded-[1rem] border-[1px]  border-[#A3AED0] p-5 text-lg"
                  placeholder="Enter password here"
                  autoComplete="off"
                />
                <div
                  className="jusitify-center absolute right-4 top-0 flex  h-[3.5rem] cursor-pointer items-center"
                  onClick={handlePasswordShow}
                >
                  <img
                    src={EyeIcon}
                    alt="eyeOpen"
                    className="h-[1.25rem] w-[1.25rem]"
                  />
                </div>
              </div>

              {formik.touched.password && formik.errors.password ? (
                <div className="text-lg	text-red-600">
                  {formik.errors.password}
                </div>
              ) : null}
            </div>
            <div>
              <div className="col mt-3">
                <img src={captchaSrc} alt="captcha" />
              </div>
              <div className="col mt-3">
                <div>
                  <input
                    className="h-[3.2rem] w-[40%] rounded-[1rem] border-[1px] border-[#A3AED0] p-5 text-lg"
                    onChange={(e) => setCaptchaText(e.target.value)}
                    placeholder="Enter Captcha Value"
                    id="user_captcha_input"
                    name="user_captcha_input"
                    type="text"
                  />
                </div>
              </div>
              <button
                className="m-4 ml-1 text-lg text-[#2B3674]	"
                type="button"
                onClick={refreshCaptcha}
              >
                Refresh Captcha
              </button>
            </div>
            <button
              type="submit"
              className="mt-5 h-[3.5rem] w-[100%] cursor-pointer rounded-full bg-blue-500 px-4 py-2 font-bold text-white hover:bg-blue-700"
            >
              Sign In
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
